import { render, staticRenderFns } from "./ReportesSMSPantalla.vue?vue&type=template&id=44ea1534&scoped=true&"
import script from "./ReportesSMSPantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesSMSPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ea1534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('44ea1534', component.options)
    } else {
      api.reload('44ea1534', component.options)
    }
    module.hot.accept("./ReportesSMSPantalla.vue?vue&type=template&id=44ea1534&scoped=true&", function () {
      api.rerender('44ea1534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ReportesSMS/ReportesSMSPantalla.vue"
export default component.exports